import React from "react";
import Typography from "@material-ui/core/Typography";

export default function Title(props) {
	return (
		<Typography variant="h5" color="textPrimary" style={{ fontWeight: 600, lineHeight: 1.2 }}>
			{props.children}
		</Typography>
	);
}
